import { render, staticRenderFns } from "./TimelineItem.vue?vue&type=template&id=16824a12&scoped=true&"
import script from "./TimelineItem.vue?vue&type=script&lang=js&"
export * from "./TimelineItem.vue?vue&type=script&lang=js&"
import style0 from "./TimelineItem.vue?vue&type=style&index=0&id=16824a12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16824a12",
  null
  
)

export default component.exports